import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  GetBookkeepingTasksQueryDTO,
  GetBookkeepingTasksResponse,
} from './bookkeeping.types';

function useBookkeepingTasks(
  corporationId: number,
  query?: GetBookkeepingTasksQueryDTO
) {
  const queryParams = new URLSearchParams();

  if (query?.status && query.status.length > 0) {
    query.status.forEach((status) => {
      queryParams.append('status', status);
    });
  }

  const queryString = queryParams.toString();
  const url = `bookkeeping/${corporationId}/tasks${
    queryString ? `?${queryString}` : ''
  }`;

  const { data, error, mutate, isLoading } =
    useSWR<GetBookkeepingTasksResponse>(
      corporationId ? url : null,
      SWRFetcher({
        method: 'GET',
      })
    );

  return {
    data,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useBookkeepingTasks as useGetBookkeepingTasks };
